package com.hyperether.goodjob.database

import app.cash.sqldelight.async.coroutines.awaitAsList
import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.hyperether.goodjob.models.User
import com.hyperether.goodjob.repository.Mapper
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow

class UserDaoImpl(private val sharedDatabase: SharedDatabase) : UserDao {

    override suspend fun insertUser(user: User) {
        sharedDatabase { database ->
            database.appDatabaseQueries.transaction {
                database.appDatabaseQueries.insertUser(
                    _id = user._id,
                    fullName = user.fullName,
                    email = user.email,
                    password = user.password,
                    confirmStatus = user.confirmStatus,
                    role = user.role,
                    workspace_ids = user.workspaceId,
                    status = user.status,
                    teams = Mapper().listAsJson(user.teams),
                    address = user.address,
                    city = user.city,
                    contry = user.country,
                    zip = user.zip,
                    phone = user.phone,
                    skills = Mapper().listAsJson(user.skills),
                    customerId = user.customerId,
                    upcomingLeave = user.upcomingLeave ?: "",
                    workingHours = Mapper().objectAsJson(user.workingHours),
                    pendingPlanId = user.pendingPlanId,
                    subscriptionEndsAt = user.subscriptionEndsAt?.toString() ?: "",
                    lang = user.lang
                )
            }
        }
    }

    override suspend fun getUsersFlow(): Flow<List<com.hyperether.goodjob.database.User>> {
        return sharedDatabase { database ->
            database.appDatabaseQueries
                .getUsers()
                .asFlow()
                .mapToList(Dispatchers.Default)
        }
    }

    override suspend fun getUsers(): List<com.hyperether.goodjob.database.User> =
        sharedDatabase { database ->
            database.appDatabaseQueries.getUsers().awaitAsList()
        }

    override suspend fun deleteUsersByIds(ids: List<Long>) {
        sharedDatabase { database ->
            database.appDatabaseQueries.deleteUsersByIds(ids)
        }
    }

    override suspend fun updateUserById(user: User) {
        sharedDatabase { database ->
            database.appDatabaseQueries.transaction {
                database.appDatabaseQueries.updateUserById(
                    id = user._id,
                    _id = user._id,
                    fullName = user.fullName,
                    email = user.email,
                    password = user.password,
                    confirmStatus = user.confirmStatus,
                    role = user.role,
                    workspace_ids = user.workspaceId,
                    planId = user.planId,
                    phone = user.phone,
                    city = user.city,
                    country = user.country,
                    zip = user.zip,
                    address = user.address,
                    status = user.status,
                    skills = Mapper().listAsJson(user.skills),
                    teams = Mapper().listAsJson(user.teams),
                    customerId = user.customerId,
                    upcomingLeave = user.upcomingLeave,
                    workingHours = Mapper().objectAsJson(user.workingHours),
                    pendingPlanId = user.pendingPlanId,
                    subscriptionEndsAt = user.subscriptionEndsAt?.toString() ?: "",
                    lang = user.lang
                )
            }
        }
    }

    override suspend fun deleteUserById(id: String) {
        sharedDatabase { database ->
            database.appDatabaseQueries.deleteUserById(id)
        }
    }

    override suspend fun deleteAllUsers() {
        sharedDatabase { database ->
            database.appDatabaseQueries.deleteAllUsers()
        }
    }
}